const pkg = require("../../../package.json");

export default {
  name: pkg.name,
  version: pkg.version,
  env: process.env.REACT_APP_ENV || process.env.NODE_ENV
};
